// extracted by mini-css-extract-plugin
export default {"form":"login_form__2L96z","link":"login_link__2qae1"};